import { render, staticRenderFns } from "./hamburger.vue?vue&type=template&id=2dd37fdc&"
import script from "./hamburger.vue?vue&type=script&lang=js&"
export * from "./hamburger.vue?vue&type=script&lang=js&"
import style0 from "./hamburger.vue?vue&type=style&index=0&id=2dd37fdc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports